import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class LoginCompletedEventTracking extends BaseEventTracking {
  /**
   * @var {string}
   */
  static eventName = SegmentEvent.LOGIN_COMPLETED;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {string}
   */
  userName;

  /**
   * @var {string}
   */
  userRole;

  /**
   * @param {AuthUser} authUser
   */
  constructor(authUser) {
    super();
    this.userId = authUser.id;
    this.userName = authUser.name;
    this.userRole = authUser.estateAccount?.roleName ?? authUser.roleName;
  }
}
